import {CacheClearJobStatus} from "../../../deleteUrls/DeleteUrlsState";

type BulkDeleteResultProps = {
  readonly jobStatus: CacheClearJobStatus;
  readonly deletedCount?: number;
};

const BulkDeleteResult = (props: BulkDeleteResultProps): JSX.Element => {
  const {jobStatus, deletedCount} = props;

  if (jobStatus === CacheClearJobStatus.processing) {
    return (
      <div className="bulk-delete-result">
        <div className="bulk-delete-spinner" aria-hidden="true" />
        <h2 className="h4">Deletion in progress</h2>
        <p className="text-muted mb-0">The cache-clear job is running. Polling status every 10s…</p>
      </div>
    );
  }

  return (
    <div className="bulk-delete-result">
      <div className="bulk-delete-result-ring" aria-hidden="true">
        ✓
      </div>
      <h2 className="h4">Deletion complete</h2>
      {deletedCount !== undefined ? (
        <p className="mb-0">
          Deleted <span className="bulk-delete-result-count">{deletedCount.toLocaleString()}</span> entries
        </p>
      ) : (
        <p className="text-muted mb-0">Deletion complete — deleted-entry count is unavailable.</p>
      )}
    </div>
  );
};

export default BulkDeleteResult;
